import { reducer as ingenicoReducer } from './ingenico'
import { reducer as sixcardsReducer } from './sixcards'
import { reducer as monerisReducer } from './moneris'
import { reducer as pagseguroReducer } from './pagseguro'

const pspReducers = {
    INGENICO: ingenicoReducer,
    SIXCARDS: sixcardsReducer,
    MONERIS: monerisReducer,
    PAGSEGURO: pagseguroReducer,
}

export const reducer = pspReducers[window.PAYMENT_SERVICE_PROVIDER]
